// 路由配置
import Vue from 'vue'
import VueRouter from 'vue-router'
import { routers } from './router'
Vue.use(VueRouter)
// 路由配置
const RouterConfig = {
    // mode: 'history',
    routes: routers
}

const router = new VueRouter(RouterConfig)

function loadStorage (to) {
    sessionStorage.route = to.path
    let allProvinceCity = localStorage.allProvinceCity !== undefined ? JSON.parse(localStorage.allProvinceCity) : [];
    let allProvinceCityCounty = localStorage.allProvinceCityCounty !== undefined ? JSON.parse(localStorage.allProvinceCityCounty) : [];
    let allrouteProvince = localStorage.routeProvince !== undefined ? JSON.parse(localStorage.routeProvince) : [];

    let province = []
    allrouteProvince.forEach(function (value, index, array) {
        if (value.RouteName === to.path) {
            let p = {}
            p.label = value.ProvinceName
            p.value = value.ProvinceID
            let index = province.findIndex(item => { return item.value === value.ProvinceID })
            if (index === -1) {
                province.push(p)
            }
        }
    })

    let provinceCity = []
    allProvinceCity.forEach(function (value, index, array) {
        if (allrouteProvince.findIndex(item => item.RouteName === to.path && item.ProvinceID === value.value) > -1) {
            provinceCity.push(value)
        }
    })

    let provinceCityCounty = []
    allProvinceCityCounty.forEach(function (value, index, array) {
        if (allrouteProvince.findIndex(item => item.RouteName === to.path && item.ProvinceID === value.value) > -1) {
            provinceCityCounty.push(value)
        }
    })

    sessionStorage.provinceCity = provinceCity.length > 0 ? JSON.stringify(provinceCity) : null
    sessionStorage.provinceCityCounty = provinceCityCounty.length > 0 ? JSON.stringify(provinceCityCounty) : null
    sessionStorage.province = province.length > 0 ? JSON.stringify(province) : null
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(m => m.meta.requireAuth)) {
        let jurisdiction = false
        if (localStorage.routeAll) {
            localStorage.routeAll.split(',').forEach(function (value, index, array) {
                if (to.path === value) {
                    jurisdiction = true
                    return false
                }
            })
        }
        if (to.path === '/login') {
            jurisdiction = true
        } else if (to.path === '/home/index') {
            jurisdiction = true
        } else if (to.path === '/') {
            jurisdiction = true
        }
        if (localStorage.tokenStorage === 'tokenStorage') {
            if (jurisdiction) {
                loadStorage(to)
                next()
            } else {
                if (to.fullPath === '/403') {
                    next()
                } else {
                    next('/403')
                }
            }
        } else {
            if (to.fullPath === '/login') {
                next()
            } else
                if (to.path === '/login' && to.query.code !== undefined) {
                    next()
                } else {
                    next('/login')
                }
        }
    } else {
        if (to.fullPath === '/404' || to.fullPath === '/loginJump') {
            next()
        } else {
            next('/404')
        }
    }
})
router.afterEach((to, from, next) => {
    // return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js